/**
 * 작성자 : 박승호
 * 날짜 : 2024.10.02
 * 기능 : 데이터 처리시 스피너 로딩 상태 보여주기
 */

import styled from 'styled-components';

const Root = styled.button`
  color: var(--btn-text);
  padding: 0 0.75rem;
  min-width: 6rem;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;
  height: 2.5rem;
  user-select: none;

  &.red {
    /* 전역 유틸 .red/.blue/.green(color)와 modifier 클래스가 동수라 주입 순서에 따라 글자색이 흔들림 → 명시해 specificity 우위 확보 */
    color: var(--btn-text);
    background-color: var(--filled-red);

    &:hover {
      background-color: rgba(246, 78, 96, 0.6);
    }

    &:disabled {
      background-color: rgba(246, 78, 96, 0.6);
      cursor: default;
    }
  }

  &.blue {
    color: var(--btn-text);
    background-color: var(--selected-primary);

    &:hover {
      color: #eaeaea;
      background-color: rgba(59, 123, 243, 0.8);
    }
    &:disabled {
      background-color: rgba(59, 123, 243, 0.8);
      cursor: default;
    }
  }

  &.green {
    color: var(--btn-text);
    background-color: var(--teal-700);

    &:hover {
      background-color: rgba(102, 187, 106, 0.8);
    }

    &:disabled {
      background-color: rgba(102, 187, 106, 0.8);
      cursor: default;
    }
  }

  &:hover {
    box-shadow: none;
  }

  &.isLoading {
    cursor: not-allowed;

    .spinner {
      display: block;
    }
  }

  .spinner {
    display: none;
    width: 1rem;
    height: 1rem;

    span {
      display: block;
      width: 1rem;
      height: 1rem;
      border: 2px solid transparent;
      border-radius: 50%;
      border-right-color: rgba(255, 255, 255, 0.7);
      animation: spinner-anim 0.8s linear infinite;
    }
  }

  @keyframes spinner-anim {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

interface Props {
  text: string;
  isLoading: boolean;
  disabled?: boolean;
  color: 'red' | 'blue' | 'green';
  onClick: () => void;
}

const LoadButton = ({ text, isLoading, disabled = false, color, onClick }: Props) => {
  return (
    <Root className={`${isLoading ? 'isLoading' : ''} ${color}`} onClick={onClick} disabled={disabled || isLoading}>
      <div className='spinner'>
        <span />
      </div>
      {text}
    </Root>
  );
};

export default LoadButton;
